export default function Logo({ size = 'md' }) {
  const sizes = {
    sm: { icon: 22, text: 14 },
    md: { icon: 28, text: 17 },
    lg: { icon: 40, text: 24 },
  }
  const s = sizes[size] ?? sizes.md

  return (
    <span className="inline-flex items-center gap-2 select-none">
      <svg
        width={s.icon}
        height={s.icon}
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="512" height="512" rx="112" fill="#4f46e5" />
        <path d="M148 216H364L335 390H177L148 216Z" fill="white" />
        <path
          d="M196 216C196 185.072 221.072 160 252 160H260C290.928 160 316 185.072 316 216"
          stroke="white"
          strokeWidth="32"
          strokeLinecap="round"
          fill="none"
        />
        <path d="M256 278V358" stroke="#4f46e5" strokeWidth="28" strokeLinecap="round" />
        <path
          d="M218 308L256 270L294 308"
          stroke="#4f46e5"
          strokeWidth="28"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span
        style={{ fontSize: s.text, letterSpacing: '-0.3px' }}
        className="font-bold text-indigo-600"
      >
        Gosellgo
      </span>
    </span>
  )
}
